import { type CSSProperties } from 'react';

import { type MarketBoxes } from '@/common/types/shop/marketBoxes';
import { type BadgeColor } from '@/components/Shop/ui/ShopUi';

import adsPng from '/img/shop/v2/packs/ads.png';
import adsWebp from '/img/shop/v2/packs/ads.webp';
import elitePng from '/img/shop/v2/packs/elite.png';
import eliteWebp from '/img/shop/v2/packs/elite.webp';
import freePng from '/img/shop/v2/packs/free.png';
import freeWebp from '/img/shop/v2/packs/free.webp';
import goldPng from '/img/shop/v2/packs/gold.png';
import goldWebp from '/img/shop/v2/packs/gold.webp';
import proPng from '/img/shop/v2/packs/pro.png';
import proWebp from '/img/shop/v2/packs/pro.webp';
import standardPng from '/img/shop/v2/packs/standard.png';
import standardWebp from '/img/shop/v2/packs/standard.webp';

interface PackLook {
  png: string;
  webp: string;
  /** Background glows */
  glow?: string;
  /** Top-left glow, lighter for the Standard pack */
  leftGlow?: string;
  badge?: { text: string; color: BadgeColor };
  /** Art box (Figma "Cases") and the crop of the art inside it */
  artBox?: CSSProperties;
  artCrop?: CSSProperties;
}

const crop = (offset: number, size: number): CSSProperties => ({
  left: `${offset}%`,
  top: `${offset}%`,
  width: `${size}%`,
  height: `${size}%`,
});

// Figma "Cases": centred 154px right of the card centre, i.e. 68px past
// its right edge — anchored to the right so narrow phones keep the gap
const bigArtBox: CSSProperties = {
  width: 224,
  height: 224,
  bottom: -48,
  right: -68,
};

const packLook: Record<MarketBoxes, PackLook> = {
  free: { png: freePng, webp: freeWebp },
  ads: { png: adsPng, webp: adsWebp },
  starter: {
    png: standardPng,
    webp: standardWebp,
    glow: '#018E9A',
    leftGlow: '#35EFFF',
    badge: { text: 'random', color: 'red' },
    artBox: { width: 196, height: 196, bottom: -64, right: -40 },
    artCrop: crop(3.28, 93.85),
  },
  pro: {
    png: proPng,
    webp: proWebp,
    glow: '#3973E5',
    badge: { text: '230% VALUE', color: 'blue' },
    artBox: bigArtBox,
    artCrop: crop(-9.09, 118.18),
  },
  gold: {
    png: goldPng,
    webp: goldWebp,
    glow: '#FFD600',
    badge: { text: '270% VALUE', color: 'yellow' },
    artBox: bigArtBox,
    artCrop: crop(2.87, 95.08),
  },
  elit: {
    png: elitePng,
    webp: eliteWebp,
    glow: '#9955FF',
    badge: { text: '290% VALUE', color: 'purple' },
    artBox: bigArtBox,
    artCrop: crop(0, 100),
  },
};

export { packLook };
